
export default {
    name: "popup_live_schedule",
    props: [],
    data(){
        return {
            selectedLang: "en",

            selectedGender: null,
            isHoveringBtn: false,
        }
    },
    computed: {

    },
    mounted(){

    },
    methods: {
        onClickGoBtn(){
            this.$emit("update:isShowIntroPopup", false);
        },
    }
}
